import { SaleDataGetSalesQuery } from "./sales/SaleDataQueries";
import { useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { useDispatch } from 'react-redux';
import { salesDataSlice } from "./sales/SaleDataStore";
import { AgTechAppLoadingProps } from "@agtech/core/data/loading/AgTechAppLoading";

const SalesAppDataContext = (props: AgTechAppLoadingProps) => {
    const dispatch = useDispatch();

    useAgTechQuery({
        query: SaleDataGetSalesQuery,
        settings: {
            eventHandlers: {
                onQuerySuccess: (saleDetails) => {
                    const defaultSale = saleDetails[0];
                    
                    dispatch(salesDataSlice.actions.setCurrentSale({
                        id: defaultSale.saleId,
                        saleName: defaultSale.saleName,
                        saleStartDate: defaultSale.saleStartDate,
                        saleEndDate: defaultSale.saleEndDate
                    }));
                }
            }
        }
    });

    return props.children;
}

export default SalesAppDataContext;